import React, { useEffect, useState } from "react";
import {
	getGuidScreenByRoute,
	getTranslateByKey,
	isNullUndefined,
	isShowControlByElementId,
	removeEmptyValues,
} from "@/main/services/utils";
import { getCheckoutSuccessMessage } from "@/main/services/utilsCheckout";
import { formatCurrency } from "@/main/services/utilsNumber";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import Button from "@/main/components/shared/button/button";
import { toast } from "react-toastify";
import { addCart, Cart, loadCart, useCartReducer } from "@/main/store/cart";
import { useSummaryReducer, getSummary } from "@/main/store/summary";
import { useCreateOrderContext } from "../../context";
import ContainerBox from "../../components/containerBox/containerBox";
import TypographyVehicle from "@/main/components/shared/typographyVehicle/typographyVehicle";
import InfoShippingCostAndTotal from "../../components/infoShippingCostAndTotal/InfoShippingCostAndTotal";
import BillingOrDeliveryAddress from "../stepOne/billingOrDeliveryAddress/billingOrDeliveryAddress";
import * as S from "./styles";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useBillingAddressReducer, getBillingAddress } from "@/main/store/billingAddress";
import { quoteApi, stripeApi } from "@/main/api";
import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import { RoutesConstants } from "@/main/routes/routesConstants";
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";
import { Controls } from "@/main/services/constants/constantsControl";
import { AwaitingReleaseResonEnum } from "@/main/services/enum/AwaitingReleaseResonEnum";
import ClaimDetails from "@/main/components/shared/claimDetails/claimDetails";
import { useQueryParamsReducer } from "@/main/store/queryParams";
import ModalStripe from "@/main/components/shared/modalStripe/modalStripe";
import useStripeCheckoutRedirect from "@/main/hooks/useStripeCheckoutRedirect";
import HubContainer from "@/main/components/shared/hub/HubContainer";
import { SendUpdatesSignalRTypeEnum } from "@/main/services/enum/SendUpdatesSignalRTypeEnum";
import CopyToClipboardText from "@/main/components/shared/copyToClipboardText/copyToClipboardText";
import { TextEllipsis } from "@/main/components/shared/styles";
import KogThreeDotsQuote from "@/main/components/shared/threeDotsQuote";
import BoxCartNoSupplierAssigned from "@/main/components/shared/boxCart/boxCartNoSupplierAssigned";
import BoxCartUnansweredItems from "@/main/components/shared/boxCart/boxCartUnansweredItems";
import BoxCart from "@/main/components/shared/boxCart/boxCart";
import { AddCartType } from "@/main/components/shared/boxCart/components/types";
import BoxCartUnansweredCanceledItems from "@/main/components/shared/boxCart/boxCartUnansweredCanceledItems";
import BoxCartUnansweredRequotedItems from "@/main/components/shared/boxCart/boxCartUnansweredRequotedItems";
import { ProcurementStatusEnum } from "@/main/services/enum/StatusProcurement";
import TotalLossComponent from "@/main/components/shared/totalLossComponent/totalLossComponent";
import { resetReducerByIdAction, useAutomaticActionReducer } from "@/main/store/automaticAction";
import { isNil } from "lodash";
import { AutomaticActionEnum } from "@/main/services/enum/AutomaticActionEnum";

function StepThreeScreen() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const billingAddressReducer = useBillingAddressReducer();
	const cartReducer = useCartReducer();
	const cartItems = cartReducer.cartItems.data;
	const cartNoSupplierAssigned = cartReducer.cartItems.dataNoSupplierAssigned;
	const cartDataUnansweredItems = cartReducer.cartItems.dataUnansweredItems;
	const cartDataUnansweredCanceledItems = cartReducer.cartItems.dataUnansweredCanceledItems;
	const cartDataUnansweredRequotedItems = cartReducer.cartItems.dataUnansweredRequotedItems;

	const [manufacturer, setManufacturer] = useState("");
	const [model, setModel] = useState("");
	const [subModel, setSubModel] = useState("");
	const [year, setYear] = useState("");
	const [bodyshop, setBodyshop] = useState("");
	const [claimNumber, setClaimNumber] = useState("");
	const [vehicleVIN, setVehicleVIN] = useState("");
	const [insurer, setInsurer] = useState("");
	const [guidBodyShop, setGuidBodyShopValue] = useState("");
	const [, setDeadlineCart] = useState("");
	const [, setIdAssessmentType] = useState(0);
	const [, setAssessmentTypeNamet] = useState("");
	const [, setApproved] = useState<boolean | null | undefined>(null);
	const [, setDeductible] = useState<number | null>(null);
	const [, setVehicleValue] = useState<number | null>(null);
	const { summary: summaryReducer } = useSummaryReducer();
	const [searchParams] = useSearchParams();
	const guidQuote = searchParams.get("guidQuote");
	const [guidCompanyBuyerValue, setGuidCompanyBuyerValue] = useState("");
	const [titleAwaitingRelease, setTitleAwaitingRelease] = useState<string | null>(null);
	const [isStripe, setIsStripe] = useState<boolean>(false);
	const [isOpenModalStripe, setIsOpenModalStripe] = useState<boolean>(false);
	const [isLoadingOpenModalStripe, setIsLoadingOpenModalStripe] = useState(false);

	const redirectToSearchOrder = useStripeCheckoutRedirect({
		quoteFilterVehicle: claimNumber,
	});

	const {
		savedData,
		handleContinueShopping,
		loadInfoOrder,
		displayModalCancel,
		displayModalReQuote,
		displayCompareSuppliers,
		isQuoteBlocked,
		integration,
		isQuoteOpen,
		isQuoteManual,
		isQuoteCanceled,
		isWaitingRelease,
		clientSecret,
		isPaymentPending,
		hasOrderByClaim,
		idProcurementStatus,
		setIsPaymentPending,
		setClientSecret,
		guidCountry,
		guidCompanyBuyer,
		refreshQuoteByGetItems,
		setIsQuoteBlocked,
	} = useCreateOrderContext();

	async function getShowStripeButton() {
		quoteApi.showStripePaymentButton(String(guidQuote)).then((res) => {
			const { result } = res.data;
			setIsStripe(result);
		});
	}

	useEffect(() => {
		dispatch(
			getSummary({
				guid: String(guidQuote),
			}),
		);
		getShowStripeButton();
	}, []);

	useEffect(() => {
		if (summaryReducer.data !== null) {
			const { manufacturer, model, subModel, year } = summaryReducer.data.vehicle;
			const {
				bodyshop,
				claimNumber,
				guidBodyshop,
				vehicleVIN,
				insurer,
				deadlineCart,
				idAssessmentType,
				assessmentTypeName,
				approved,
				deductible,
				vehicleValue,
			} = summaryReducer.data;
			setManufacturer(manufacturer);
			setModel(model);
			setSubModel(subModel);
			setYear(year);
			setBodyshop(bodyshop);
			setClaimNumber(claimNumber);
			setVehicleVIN(vehicleVIN);
			setInsurer(insurer);
			setDeadlineCart(deadlineCart);
			setIdAssessmentType(idAssessmentType);
			setAssessmentTypeNamet(assessmentTypeName);
			setApproved(approved);
			setDeductible(deductible || null);
			setVehicleValue(vehicleValue || null);
			setGuidBodyShopValue?.(String(guidBodyshop));
		}
	}, [summaryReducer]);
	useEffect(() => {
		if (savedData && savedData.length > 0) {
			const STEP_DATA_VEHICLE: number = 0;
			if (savedData[STEP_DATA_VEHICLE].data && savedData[STEP_DATA_VEHICLE].data !== null) {
				const { guidCompanyBuyer } = savedData[STEP_DATA_VEHICLE].data;
				if (guidCompanyBuyer) {
					setGuidCompanyBuyerValue(guidCompanyBuyer);
				}
			}
		}
	}, [savedData]);

	useEffect(() => {
		if (summaryReducer.data !== null) {
			if (typeof guidBodyShop === "string" && guidBodyShop !== "")
				dispatch(
					getBillingAddress({
						guidCompany: guidBodyShop && guidBodyShop !== undefined ? guidBodyShop : guidCompanyBuyerValue || "",
					}),
				);
		}
	}, [guidBodyShop, guidCompanyBuyerValue]);

	const [optionsSelectedBillingAddress, setOptionsSelectedBillingAddress] = useState<string | null>(null);
	const [openModalAwaitingRelease, setOpenModalAwaitingRelease] = useState<boolean>(false);
	const [openModalSelectSupplier, setOpenModalSelectSupplier] = useState(false);
	const [loadingGenerateOrder, setLoadingGenerateOrder] = useState<boolean>(false);
	const [loadingFindSupplierForParts, setLoadingFindSupplierForParts] = useState<boolean>(false);
	const [, setDeliveryBySupplier] = useState<boolean>(false);
	const [openModalClaimDetails, setOpenModalClaimDetails] = useState<boolean>(false);

	const totalPriceCart = cartReducer.summary.total;
	const totalCart = totalPriceCart;

	const showReopenOfferButton = isShowControlByElementId(Controls.IdReopenOffer);
	const showPrices = isShowControlByElementId(Controls.IdShowPrices);
	const cancelParts = isShowControlByElementId(Controls.IdCancelPartQuoteSummary);

	useEffect(() => {
		const allDeliveriesBySupplier = cartItems.every((item) => item.deliveryBySupplier === true);
		setDeliveryBySupplier(allDeliveriesBySupplier);
	}, [cartItems]);

	const { automaticAction } = useAutomaticActionReducer();

	useEffect(() => {
		if (!isNil(automaticAction.data) && !isNil(guidQuote) && !loadingGenerateOrder) {
			const findAction = automaticAction.data.find(
				(x) => x.idAction == AutomaticActionEnum.GenerateOrderBySaveBuyerPartAsnwer && x.id == guidQuote,
			);

			if (!isNil(findAction)) {
				dispatch(resetReducerByIdAction(guidQuote));
				handleGenerateOrder();
			}
		}
	}, [automaticAction.data, guidQuote]);

	async function searchSupplierForParts() {
		setLoadingFindSupplierForParts(true);
		setLoadingGenerateOrder(true);

		quoteApi
			.addMissingItemsToCart(String(guidQuote))
			.then((res) => {
				const findSupplier = res.data.result;
				setOpenModalSelectSupplier(false);
				if (!findSupplier) {
					setLoadingGenerateOrder(false);
					toast.error(getTranslateByKey("information.noSuppliersWereFoundForTheParts"));
				} else {
					handleGenerateOrder();
				}
			})
			.finally(() => setLoadingFindSupplierForParts(false));
	}

	async function handleGenerateOrder() {
		setLoadingGenerateOrder(true);

		let validateTotalLoss: {
			approved: boolean;
			awaitingReleaseReson: number | null;
			changedToAwaitingRelease: boolean;
		} = {
			approved: false,
			awaitingReleaseReson: null,
			changedToAwaitingRelease: false,
		};

		if (hasWaitinReleasePermission || !isWaitingRelease) {
			let hasValidationError = false;
			await quoteApi
				.validateawaitingreleaseaprroval(String(guidQuote))
				.then((res) => {
					const resData = res.data.result;
					validateTotalLoss = {
						approved: resData.approved,
						awaitingReleaseReson: resData.awaitingReleaseReson,
						changedToAwaitingRelease: resData.changedToAwaitingRelease,
					};
				})
				.catch(() => {
					hasValidationError = true;
				});

			if (hasValidationError) {
				setLoadingGenerateOrder(false);
				return;
			}

			if (!validateTotalLoss.changedToAwaitingRelease) {
				if (
					!hasWaitinReleasePermission &&
					!isWaitingRelease &&
					!validateTotalLoss.approved &&
					!isNullUndefined(validateTotalLoss.awaitingReleaseReson)
				) {
					return changeQuoteToAwaitingRelease();
				}
				if (
					validateTotalLoss &&
					!validateTotalLoss.approved &&
					!isNullUndefined(validateTotalLoss.awaitingReleaseReson)
				) {
					setTitelModal(validateTotalLoss.awaitingReleaseReson);
					return setOpenModalAwaitingRelease(true);
				}
				submitGenerateOrder();
			} else {
				toast.success(getTranslateByKey("information.quoteChangedToAwaitingRelease"));
				setLoadingGenerateOrder(false);
				navigate(`${RoutesConstants.orderSearchOrder}?quoteFilterVehicle=${claimNumber}`);
			}
		} else {
			toast.error(getTranslateByKey("information.awaitingReleaseWithoutPermission"));
			setLoadingGenerateOrder(false);
		}
	}

	function submitGenerateOrder() {
		setOpenModalAwaitingRelease(false);
		const requestCheckout = removeEmptyValues({
			guidQuote: String(guidQuote),
			guidBillingAddress: String(optionsSelectedBillingAddress),
		});
		setClientSecret("");
		if (isStripe) {
			quoteApi
				.buyNow(requestCheckout)
				.then(
					(res) => {
						const resData = res.data.result;

						setIsOpenModalStripe(true);
						setClientSecret(resData.stripeClientSecret);
						setIsPaymentPending(true);

						return;
					},
					() => {
						dispatch(loadCart(guidQuote || ""));
					},
				)
				.catch(() => {})
				.finally(() => {
					setLoadingGenerateOrder(false);
					setIsLoadingOpenModalStripe(false);
				});
		} else {
			quoteApi
				.checkout(requestCheckout)
				.then(
					(res) => {
						const resData = res.data;

						if (resData?.isWarning) {
							if (resData.message && !resData.isHideToastNotification) {
								toast.warn(resData.message);
							}
						} else {
							toast.success(getCheckoutSuccessMessage(resData.result));
						}

						navigate(`${RoutesConstants.orderSearchOrder}?quoteFilterVehicle=${claimNumber}`);
					},
					() => {
						dispatch(loadCart(guidQuote || ""));
					},
				)
				.catch(() => {})
				.finally(() => setLoadingGenerateOrder(false));
		}
	}

	function changeQuoteToAwaitingRelease() {
		setLoadingGenerateOrder(true);
		quoteApi
			.changeQuoteToAwaitingRelease(String(guidQuote))
			.then((res) => {
				const resData = res.data.result;
				if (resData) {
					toast.success(getTranslateByKey("information.quoteChangedToAwaitingRelease"));
					navigate(`${RoutesConstants.orderSearchOrder}?quoteFilterVehicle=${claimNumber}`);
				}
			})
			.finally(() => setLoadingGenerateOrder(false));
	}

	function renderBillingAddress() {
		return (
			<BillingOrDeliveryAddress
				isBillingAddress={true}
				addressData={billingAddressReducer.billingAddress.data}
				isError={billingAddressReducer.billingAddress.isError}
				isLoading={billingAddressReducer.billingAddress.isLoading}
				optionsSelectedDeliveryAddress={optionsSelectedBillingAddress}
				setOptionsSelectedDeliveryAddress={setOptionsSelectedBillingAddress}
				label={getTranslateByKey("information.shippingAddress")}
				hasItemsOfCarts={false}
				guidAddressSaved={null}
				integration={integration}
				isQuoteOpen={isQuoteOpen}
				isQuoteManual={isQuoteManual}
				isQuoteCanceled={isQuoteCanceled}
			/>
		);
	}

	const { queryParams } = useQueryParamsReducer();
	function handleClickBack(e: React.KeyboardEvent<any>) {
		if (e.ctrlKey) {
			const saveFilters = !isNullUndefined(queryParams.data)
				? queryParams.data[RoutesConstants.orderSearchOrder]
				: null;

			const params = new URLSearchParams();

			if (!isNullUndefined(saveFilters)) {
				Object.keys(saveFilters).forEach((key) => {
					params.append(key, saveFilters[key]);
				});
			}

			const formattedParams = params.size > 0 ? `?${params}` : "";
			return window.open(`#${RoutesConstants.orderSearchOrder}${formattedParams}`);
		} else {
			return navigate(`${RoutesConstants.orderSearchOrder}`);
		}
	}

	function setTitelModal(awaitingReleaseEnum: number) {
		switch (awaitingReleaseEnum) {
			case AwaitingReleaseResonEnum.QuoteChangeStatusDamagePayment:
				setTitleAwaitingRelease(
					getTranslateByKey("information.thisQuoteIsADamagePaymentAreYouSureYouWantToGenerateTheOrder"),
				);
				break;
			case AwaitingReleaseResonEnum.QuoteChangeStatusTotalLoss:
				setTitleAwaitingRelease(
					getTranslateByKey("information.thisQuoteIsATotalLossAreYouSureYouWantToGenerateTheOrder"),
				);
				break;
			case AwaitingReleaseResonEnum.QuoteChangeStatusNotDeductible:
				setTitleAwaitingRelease(
					getTranslateByKey("information.thisQuoteHasLessThanDeductibleRepairCostsAreYouSureYouWantToGenerateTheOrder"),
				);
				break;
			case AwaitingReleaseResonEnum.QuoteChangeStatusPossibleTotalLoss:
				setTitleAwaitingRelease(
					getTranslateByKey("information.thatQuoteMightBeATotalLossAreYouSureThatWantToGenerateTheOrder"),
				);
				break;
			case AwaitingReleaseResonEnum.QuoteChangeStatusNotAprroved:
				setTitleAwaitingRelease(
					getTranslateByKey("information.thisQuoteIsNotApprovedAreYouSureYouWantToGenerateTheOrder"),
				);
				break;

			default:
				setTitleAwaitingRelease(
					getTranslateByKey("information.thatQuoteMightBeATotalLossAreYouSureThatWantToGenerateTheOrder"),
				);
				break;
		}
	}

	const handleAddCart: AddCartType = (items, guidQuoteSupplierItem) => {
		dispatch(addCart(items, guidQuoteSupplierItem));
	};

	useEffect(() => {
		const keySessionIdParam = "session_id";
		const hasSessionId = searchParams.has(keySessionIdParam);

		if (hasSessionId) {
			const sessionId = String(searchParams.get(keySessionIdParam));
			stripeApi.sessionStatus(sessionId).then((res) => {
				const { result } = res.data;

				if (result === "complete") {
					redirectToSearchOrder();
				} else {
					setIsOpenModalStripe(false);
				}
			});
		}
	}, [searchParams]);

	useEffect(() => {
		if (isStripe && isPaymentPending) {
			setIsOpenModalStripe(true);
			setIsLoadingOpenModalStripe(true);
			submitGenerateOrder();
		}
	}, [isPaymentPending, isStripe]);

	const showButtonRemoveBulkPart = !isQuoteBlocked;
	const showButtonRequoteBulkPart = !isQuoteOpen && !isWaitingRelease;
	const hasWaitinReleasePermission = isShowControlByElementId(Controls.IdReleaseOrderControl);
	const showPartTypeControl = isShowControlByElementId(Controls.IdSearchQuoteRequotePartType);

	const isDisabledGenerateOrderButton =
		loadingGenerateOrder ||
		(cartReducer.cartItems.data.length === 0 && cartNoSupplierAssigned === null) ||
		(cartDataUnansweredItems?.parts?.length ?? 0) > 0 ||
		(integration && isQuoteOpen) ||
		isQuoteCanceled ||
		cartReducer.cartItems.isLoading ||
		cartReducer.cartItems.isLoadingUpdate;

	return (
		<>
			<S.Container>
				<ContainerBox title={getTranslateByKey("information.summary")}>
					<TypographyVehicle
						manufacturer={manufacturer}
						model={model}
						subModel={subModel}
						year={year}
						licensePlate={
							savedData[0].data &&
							savedData[0].data.vehicleLicensePlate !== "" &&
							!isNullUndefined(savedData[0].data.vehicleLicensePlate)
								? `(${savedData[0].data.vehicleLicensePlate})`
								: ""
						}
					/>
					<S.ContainerItems>
						<S.ItemSummary>{getTranslateByKey("information.insurer")}:</S.ItemSummary>
						{insurer}
					</S.ContainerItems>
					<S.ContainerItems>
						<S.ItemSummary>{getTranslateByKey("information.bodyshop")}:</S.ItemSummary>
						{bodyshop}
					</S.ContainerItems>
					<S.ContainerItems>
						<S.ItemSummary>{getTranslateByKey("information.claimNumber")}:</S.ItemSummary>
						{claimNumber}
						{integration && (
							<ClaimDetails
								guidScreen={getGuidScreenByRoute(RoutesConstants.orderCreateOrder)}
								showPrices={showPrices}
								openModalClaimDetails={openModalClaimDetails}
								guidQuote={String(guidQuote)}
								setOpenModalClaimDetails={setOpenModalClaimDetails}
							/>
						)}
					</S.ContainerItems>
					<S.VinSummary as="div">
						<S.ItemSummary>{getTranslateByKey("information.vin")}:</S.ItemSummary>
						<CopyToClipboardText
							label={getTranslateByKey("information.vin")}
							valueToCopy={vehicleVIN ? vehicleVIN : ""}
						>
							{vehicleVIN && <TextEllipsis>{vehicleVIN}</TextEllipsis>}
						</CopyToClipboardText>
					</S.VinSummary>
					<S.ContainerItems>
						<TotalLossComponent guidQuote={String(guidQuote)} type="row" idStatus={idProcurementStatus ?? 0} />
					</S.ContainerItems>
					<S.AreaAbsoluteInfoQuote>
						<KogThreeDotsQuote.Root>
							<KogThreeDotsQuote.OptionImage
								guidQuote={String(guidQuote)}
								isQuoteCanceled={isQuoteCanceled}
								canDownloadImages={isShowControlByElementId(Controls.IdDownloadImagesCreateOrderControl)}
							/>
							<KogThreeDotsQuote.OptionHistory
								guidQuote={String(guidQuote)}
								guidScreen={getGuidScreenByRoute(RoutesConstants.orderCreateOrder)}
							/>
							<KogThreeDotsQuote.OptionHasOrderByClaim claimNumber={claimNumber} hasOrderByClaim={hasOrderByClaim} />
							<KogThreeDotsQuote.OptionRequoteParts
								dataCart={cartReducer}
								setIsQuoteBlocked={setIsQuoteBlocked}
								guidQuote={String(guidQuote)}
								loadInfoOrder={loadInfoOrder}
								loadCart={(guidQuote) => dispatch(loadCart(guidQuote))}
								refreshQuoteByGetItems={refreshQuoteByGetItems}
								numbersParts={cartItems.length}
								showButtonRemoveBulkPart={showButtonRequoteBulkPart}
								showPartTypeControl={showPartTypeControl}
							/>
							{cancelParts && idProcurementStatus !== ProcurementStatusEnum.WaitingRelease && (
								<KogThreeDotsQuote.OptionCancelParts
									guidQuote={String(guidQuote)}
									dataCart={cartReducer}
									refreshQuoteByGetItems={refreshQuoteByGetItems}
									numbersParts={cartItems.length}
									showButtonRemoveBulkPart={showButtonRemoveBulkPart}
									isQuoteCanceled={isQuoteCanceled}
								/>
							)}
							<KogThreeDotsQuote.OptionDirectAssign
								guidQuote={String(guidQuote)}
								guidCompanyBuyer={guidCompanyBuyer}
								guidCountry={guidCountry}
								canDownloadImages={isShowControlByElementId(Controls.IdDownloadImagesCreateOrderControl)}
								isQuoteManual={idProcurementStatus == ProcurementStatusEnum.Manual}
								onSuccess={() => {
									dispatch(loadCart(String(guidQuote)));
								}}
							/>
						</KogThreeDotsQuote.Root>
					</S.AreaAbsoluteInfoQuote>
				</ContainerBox>
				{renderBillingAddress()}

				<ContainerBox>
					{cartReducer.cartItems.isLoading ? (
						<LoadingComponent />
					) : (
						<>
							{/* Items - No answered */}
							<BoxCartUnansweredItems
								dataCart={cartReducer}
								guidQuote={String(guidQuote)}
								idProcurementStatus={idProcurementStatus ?? 0}
								integration={integration}
								isPaymentPending={isPaymentPending}
								isQuoteBlocked={isQuoteBlocked}
								cart={cartDataUnansweredItems}
								addCart={handleAddCart}
								loadCart={(guidQuoteLoadCart) => dispatch(loadCart(guidQuoteLoadCart))}
								refreshQuoteByGetItems={refreshQuoteByGetItems}
								showButtonRemoveBulkPart={cancelParts}
								showButtonRequoteBulkPart={true}
								allowCloseOfferRequest
							/>

							{/* Items - NoSupplierAssigned */}
							<BoxCartNoSupplierAssigned
								dataCart={cartReducer}
								guidQuote={String(guidQuote)}
								idProcurementStatus={idProcurementStatus ?? 0}
								integration={integration}
								isPaymentPending={isPaymentPending}
								isQuoteBlocked={isQuoteBlocked}
								cart={cartNoSupplierAssigned}
								canShowButtonRemovePart={cancelParts}
								canShowButtonRequotePart={false}
								addCart={handleAddCart}
								loadCart={(guidQuoteLoadCart) => dispatch(loadCart(guidQuoteLoadCart))}
								refreshQuoteByGetItems={refreshQuoteByGetItems}
							/>

							{/* Items - Cart */}
							{cartItems.map((part: Cart, index: number) => (
								<BoxCart
									dataCart={cartReducer}
									key={index}
									cart={part}
									guidScreen={getGuidScreenByRoute(RoutesConstants.orderCreateOrder)}
									showCompareSuppliers={!isQuoteBlocked && !isPaymentPending}
									canShowDeleteBoutton={cancelParts}
									guidQuote={String(guidQuote)}
									isPaymentPending={isPaymentPending}
									isQuoteBlocked={isQuoteBlocked}
									displayCompareSuppliers={displayCompareSuppliers}
									isQuoteCanceled={isQuoteCanceled}
									refreshQuoteByGetItems={refreshQuoteByGetItems}
									idProcurementStatus={idProcurementStatus ?? 0}
									integration={integration}
									addCart={handleAddCart}
								/>
							))}

							{/* Items - No answered canceled */}
							<BoxCartUnansweredCanceledItems
								dataCart={cartReducer}
								guidQuote={String(guidQuote)}
								integration={integration}
								idProcurementStatus={idProcurementStatus ?? 0}
								isPaymentPending={isPaymentPending}
								isQuoteBlocked={isQuoteBlocked}
								cart={cartDataUnansweredCanceledItems}
								showButtonRequoteBulkPart={false}
								loadCart={(guidQuoteLoadCart) => dispatch(loadCart(guidQuoteLoadCart))}
								addCart={handleAddCart}
								refreshQuoteByGetItems={refreshQuoteByGetItems}
							/>

							{/* Items - No answered Requoted */}
							<BoxCartUnansweredRequotedItems
								cart={cartDataUnansweredRequotedItems}
								loadCart={(guidQuoteLoadCart) => dispatch(loadCart(guidQuoteLoadCart))}
							/>

							<InfoShippingCostAndTotal total={formatCurrency(totalCart)} />
						</>
					)}
				</ContainerBox>

				<S.Box>
					<S.FooterButton>
						<SecondaryButton id="id-createOrder-button-back" type="button" onClick={(event) => handleClickBack(event)}>
							{getTranslateByKey("information.back")}
						</SecondaryButton>
						{!isQuoteBlocked && (
							<>
								{cancelParts && (
									<SecondaryButton
										id="id-createOrder-button-cancel"
										type="button"
										disabled={(integration && isQuoteOpen) || isQuoteCanceled}
										onClick={() => displayModalCancel()}
									>
										{getTranslateByKey("information.cancel")}
									</SecondaryButton>
								)}
								{isQuoteManual && showReopenOfferButton && (
									<SecondaryButton
										id="id-createOrder-button-reopenOffer"
										type="button"
										onClick={() => displayModalReQuote()}
									>
										{getTranslateByKey("information.reopenOffer")}
									</SecondaryButton>
								)}

								{!isPaymentPending && (
									<SecondaryButton
										id="id-createOrder-button-continueShopping"
										type="button"
										disabled={isQuoteCanceled}
										onClick={() => {
											handleContinueShopping();
										}}
									>
										{getTranslateByKey("information.continueShopping")}
									</SecondaryButton>
								)}
								<Button
									id="id-createOrder-button-generateOrder"
									type="button"
									isLoadingLockScreen
									isLoading={loadingGenerateOrder}
									disabled={isDisabledGenerateOrderButton}
									onClick={() =>
										cartNoSupplierAssigned && cartNoSupplierAssigned !== null
											? setOpenModalSelectSupplier(true)
											: handleGenerateOrder()
									}
								>
									{isStripe ? getTranslateByKey("information.buyNow") : getTranslateByKey("information.generateOrder")}
								</Button>
							</>
						)}
						<HubContainer
							type={SendUpdatesSignalRTypeEnum.StripePaymentFlow}
							customProps={{ onPaymentCompleted: redirectToSearchOrder }}
						/>
					</S.FooterButton>
				</S.Box>
				<KogModalFadeComponent open={openModalSelectSupplier} setOpen={setOpenModalSelectSupplier}>
					<S.BoxModal>
						<S.TitleModal>
							{getTranslateByKey("information.areYouThatSystemSelectBestSupplierAndCheckOutYourQuote")}
						</S.TitleModal>
						<div
							style={{
								display: "flex",
								justifyContent: "center",
								gap: "1rem",
							}}
						>
							<SecondaryButton
								type="button"
								onClick={() => setOpenModalSelectSupplier(false)}
								id="id-createOrder-button-no"
							>
								{getTranslateByKey("information.no")}
							</SecondaryButton>
							<Button
								type="button"
								isLoading={loadingFindSupplierForParts}
								onClick={() => searchSupplierForParts()}
								id="id-createOrder-button-yes"
							>
								{getTranslateByKey("information.yes")}
							</Button>
						</div>
					</S.BoxModal>
				</KogModalFadeComponent>
				<KogModalFadeComponent open={openModalAwaitingRelease} setOpen={setOpenModalAwaitingRelease}>
					<S.BoxModal>
						{!isNullUndefined(titleAwaitingRelease) && <S.TitleModal>{titleAwaitingRelease}</S.TitleModal>}
						<div
							style={{
								display: "flex",
								justifyContent: "center",
								gap: "1rem",
							}}
						>
							<SecondaryButton
								type="button"
								onClick={() => {
									setOpenModalAwaitingRelease(false);
									setLoadingGenerateOrder(false);
									changeQuoteToAwaitingRelease();
								}}
								id="id-createOrder-button-no"
							>
								{getTranslateByKey("information.no")}
							</SecondaryButton>
							<Button type="button" onClick={() => submitGenerateOrder()} id="id-createOrder-button-yes">
								{getTranslateByKey("information.yes")}
							</Button>
						</div>
					</S.BoxModal>
				</KogModalFadeComponent>

				<ModalStripe
					guidQuote={String(guidQuote)}
					setClientSecret={setClientSecret}
					setIsPaymentPending={setIsPaymentPending}
					isOpenModal={isOpenModalStripe}
					clientSecret={clientSecret}
					isLoadingOpenModalStripe={isLoadingOpenModalStripe}
					setIsOpenModal={setIsOpenModalStripe}
				/>
			</S.Container>
		</>
	);
}

export default StepThreeScreen;
